

















































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { AccountModule } from '@/store/modules/account';
import { CancelPsProductFavorite, CancelScCatalogFavorite, GetMyScSkuFavoritePage, ScCatalogItemType } from '../api/sc';
import { GetWebSkuCategoryOptions, SKU_CATEGORY_TYPE, SkuCategoryTreeItem } from '../api/sku-category';
import MicroSprayProductCard from '../components/micro-spray-product-card.vue';

type FavoriteItem = {
  itemType: ScCatalogItemType;
  saleStatus?: string;
  saleStatusName?: string;
  canPurchase?: boolean;
  targetSn: string;
  skuSn?: string;
  enterpriseSn: string;
  supplierEnterpriseSn: string;
  name?: string;
  description: string;
  imageUrl: string;
  supplierName: string;
  firstCategoryName: string;
  secondCategoryName: string;
  sizeText: string;
  materialText: string;
  craftText: string;
  referencePrice: string;
  favoriteAt: string;
  studioName?: string;
  sizePriceList?: Array<{
    sizeOptionSn?: string;
    sizeName?: string;
    unitPrice: string | number;
    sequence?: number;
  }>;
  favorited?: boolean;
};

function normalizeArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) ? value : [];
}

@Component({
  components: {
    MicroSprayProductCard,
  },
})
export default class MyFavorite extends Vue {
  loading = false;
  cancelLoadingKey = '';
  chatQrCodeUrl = 'https://cdn-h.gongfudou.com/Epson/wechat_qrcoder.png';
  pageNum = 1;
  pageSize = 12;
  total = 0;
  activeTab: 'SUPPLY_CHAIN' | 'PS_PRODUCT' = 'SUPPLY_CHAIN';
  records: FavoriteItem[] = [];
  categoryTree: SkuCategoryTreeItem[] = [];
  secondCategoryOptions: SkuCategoryTreeItem[] = [];

  filters = {
    keyword: '',
    firstCategoryCode: '',
    secondCategoryCode: '',
    sortType: 'favoriteTimeDesc',
  };

  get visibleCategoryChips() {
    return this.categoryTree.filter(item => item.isEnabled !== false).slice(0, 6);
  }

  async mounted() {
    if (!this.ensureLogin()) {
      return;
    }
    if (this.$route.query.tab === 'PS_PRODUCT') {
      this.activeTab = 'PS_PRODUCT';
    }
    await Promise.all([this.fetchCategoryOptions(), this.fetchList(1)]);
  }

  ensureLogin() {
    if (AccountModule.isLogined) {
      return true;
    }
    this.$message.warning('请先登录后查看我的收藏');
    this.$router.replace({
      path: '/login',
      query: {
        redirect: this.$route.fullPath,
      },
    });
    return false;
  }

  async fetchCategoryOptions() {
    try {
      const categoryType = this.activeTab === 'PS_PRODUCT' ? SKU_CATEGORY_TYPE.SAMPLE : SKU_CATEGORY_TYPE.JD_ECO;
      const res = await GetWebSkuCategoryOptions(categoryType);
      this.categoryTree = normalizeArray<SkuCategoryTreeItem>(res);
      this.syncSecondCategoryOptions(true);
    } catch (error) {
      this.categoryTree = [];
      this.secondCategoryOptions = [];
    }
  }

  async fetchList(pageNum = this.pageNum) {
    this.loading = true;
    try {
      const res = await GetMyScSkuFavoritePage({
        favoriteTab: this.activeTab,
        keyword: this.filters.keyword || undefined,
        firstCategoryCode: this.filters.firstCategoryCode || undefined,
        secondCategoryCode: this.filters.secondCategoryCode || undefined,
        sortType: this.filters.sortType,
        pageNum,
        pageSize: this.pageSize,
      });
      this.pageNum = Number((res && res.current) || pageNum);
      this.pageSize = Number((res && res.size) || this.pageSize);
      this.total = Number((res && res.total) || 0);
      this.records = normalizeArray<any>(res && res.records)
        .map(item => ({
          ...item,
          itemType: item.itemType || 'SC_SKU',
          targetSn: item.targetSn || item.skuSn || '',
          name: item.name || item.description || '',
          favorited: true,
        }))
        .filter(item => item.itemType === 'SC_SKU' || item.itemType === 'SC_SYNC_PRODUCT' || item.itemType === 'PS_PRODUCT');
    } catch (error) {
      this.records = [];
      this.total = 0;
    } finally {
      this.loading = false;
    }
  }

  syncSecondCategoryOptions(resetInvalid = false) {
    const firstCategory = this.categoryTree.find(item => item.code === this.filters.firstCategoryCode);
    this.secondCategoryOptions = firstCategory && Array.isArray(firstCategory.children) ? firstCategory.children : [];
    if (
      resetInvalid &&
      this.filters.secondCategoryCode &&
      !this.secondCategoryOptions.some(item => item.code === this.filters.secondCategoryCode)
    ) {
      this.filters.secondCategoryCode = '';
    }
  }

  handleFirstCategoryChange(code: string) {
    this.filters.firstCategoryCode = code;
    this.syncSecondCategoryOptions(true);
    this.handleSearch();
  }

  handleSearch() {
    this.fetchList(1);
  }

  handlePageChange(page: number) {
    this.fetchList(page);
  }

  buildItemKey(item: FavoriteItem) {
    return `${item.itemType}:${item.targetSn}`;
  }

  displayItemName(item: FavoriteItem) {
    return item.name || item.description || '未填写商品名称';
  }

  async handleCancelFavorite(item: FavoriteItem) {
    if (!item.targetSn || this.cancelLoadingKey) {
      return;
    }
    this.cancelLoadingKey = this.buildItemKey(item);
    try {
      if (item.itemType === 'PS_PRODUCT') {
        await CancelPsProductFavorite({ productSn: item.targetSn });
      } else {
        await CancelScCatalogFavorite({
          targetType: item.itemType,
          targetSn: item.targetSn,
        });
      }
      this.$message.success('已取消收藏');
      if (this.records.length === 1 && this.pageNum > 1) {
        await this.fetchList(this.pageNum - 1);
        return;
      }
      await this.fetchList(this.pageNum);
    } finally {
      this.cancelLoadingKey = '';
    }
  }

  handleSelectFavorite(item: FavoriteItem) {
    if ((item.itemType !== 'SC_SYNC_PRODUCT' && item.itemType !== 'PS_PRODUCT') || !item.targetSn || item.canPurchase === false) {
      return;
    }
    this.$router.push({
      path: '/sampleApply',
      query: {
        productSn: item.targetSn,
        source: item.itemType === 'PS_PRODUCT' ? 'PS_FAVORITE' : 'SC_FAVORITE',
      },
    });
  }

  async handleTabChange(tab: 'SUPPLY_CHAIN' | 'PS_PRODUCT') {
    if (this.activeTab === tab) {
      return;
    }
    this.activeTab = tab;
    this.pageNum = 1;
    this.filters.firstCategoryCode = '';
    this.filters.secondCategoryCode = '';
    this.secondCategoryOptions = [];
    await this.fetchCategoryOptions();
    await this.fetchList(1);
  }

  handleBack() {
    this.$router.push('/account');
  }

  handleChatSupplier(item: FavoriteItem) {
    const qrCodeNode = this.$createElement('div', { class: 'supply-chain-chat-dialog' }, [
      this.$createElement('img', {
        class: 'supply-chain-chat-qrcode',
        attrs: {
          src: this.chatQrCodeUrl,
          alt: '微信二维码',
        },
      }),
      this.$createElement('div', { class: 'supply-chain-chat-tip' }, item.supplierName || '供应商'),
    ]);

    this.$msgbox({
      title: '立即私聊',
      message: qrCodeNode,
      customClass: 'supply-chain-chat-message-box',
      confirmButtonText: '关闭',
      center: true,
    }).catch(() => undefined);
  }

  buildCategoryText(item: FavoriteItem) {
    const values = [item.firstCategoryName, item.secondCategoryName].filter(Boolean);
    return values.length ? values.join(' / ') : '未配置分类';
  }

  formatFavoriteTime(value: string) {
    if (!value) {
      return '--';
    }
    return String(value)
      .replace('T', ' ')
      .slice(0, 19);
  }

  formatFavoriteDate(value: string) {
    return this.formatFavoriteTime(value).slice(0, 10);
  }
}
